/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IncortaSubscriptionStatusEnum } from './incortaSubscriptionStatusEnum';


export interface IncortaSubscription { 
    id: number;
    serial_number?: string;
    sku?: string;
    start_date?: string;
    end_date?: string;
    licensee_name?: string;
    licensee_erp_nbr?: string;
    licensee_classification?: string;
    licensee_sales_region?: string;
    parent_account_name?: string;
    rpt_geo?: string;
    contract_nbr?: string;
    line_nbr?: string;
    header_status?: string;
    line_status?: string;
    erp_site?: string;
    quantity?: number;
    creation_date?: Date;
    last_update_date?: Date;
    status: IncortaSubscriptionStatusEnum;
    info?: string;
    tenant_id?: string;
    sn_extension_date?: string;
    technical_contact?: string;
    tech_contact_email_address?: string;
    end_cust_country_code?: string;
    subscription_type?: string;
    created_ts: Date;
    updated_ts: Date;
}
export namespace IncortaSubscription {
}


